import {
  normalizeOptionText,
  safeParseStringArray,
} from "@/utils/questionnaire/optionText"

export const isOptionSelected = (currentValue: string, optionText: string) => {
  const normalizedValue = normalizeOptionText(currentValue).toLowerCase()
  const normalizedOption = normalizeOptionText(optionText).toLowerCase()
  return normalizedValue === normalizedOption
}

export const isOptionSelectedInList = (
  currentValue: string,
  optionText: string,
) => {
  const selected = safeParseStringArray(currentValue).map((v) =>
    normalizeOptionText(v).toLowerCase(),
  )
  const normalizedOption = normalizeOptionText(optionText).toLowerCase()
  return selected.includes(normalizedOption)
}

export const toggleOptionInValue = (
  currentValue: string,
  optionText: string,
  answerOptions?: string[] | null,
) => {
  const normalizedTarget = normalizeOptionText(optionText)
  if (!normalizedTarget) return currentValue

  const rawList = safeParseStringArray(currentValue)

  // Sanitize: if we know the valid answer options, drop any items that are
  // not among them. This discards legacy free-text summary answers (e.g. the
  // AI writing "Alle fünf Grundsätze werden eingehalten." into a multi-
  // select field) so that toggling a checkbox starts from a clean state and
  // produces a payload that passes backend validation.
  const validOptionsLower = (answerOptions ?? [])
    .map((o) => normalizeOptionText(o).toLowerCase())
    .filter(Boolean)
  const currentList =
    validOptionsLower.length > 0
      ? rawList.filter((v) =>
          validOptionsLower.includes(normalizeOptionText(v).toLowerCase()),
        )
      : rawList

  const existingIdx = currentList.findIndex(
    (v) =>
      normalizeOptionText(v).toLowerCase() === normalizedTarget.toLowerCase(),
  )

  const nextList =
    existingIdx >= 0
      ? currentList.filter((_, idx) => idx !== existingIdx)
      : [...currentList, normalizedTarget]

  return JSON.stringify(nextList.filter((v) => normalizeOptionText(v)))
}
